import { authApi } from "@RTKQuery/basic";
import authAuthApi from "../auth/auth";
import { ITag } from "@interfaces/user/tag";
import { IProxy } from "@interfaces/user/proxy";
import purchasesAuthApi from "../purchases/purchases";

const tagsAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getAllTags: build.query<ITag[], void>({
            query: () => "tags",
        }),
        addTag: build.mutation<ITag, {
            purchase_id: IProxy["id"],
            body: Partial<ITag>,
            params: {
                page: number,
                limit: number,
                search: string,
                tag_ids: ITag["id"][]
            }
        }>({
            query: ({ purchase_id, body }) => ({
                url: `tags/${purchase_id}/create_connect`,
                method: "POST",
                body
            }),
            async onQueryStarted({ params, purchase_id, body }, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    if (data) {
                        if (body.name) {
                            dispatch(tagsAuthApi.util.updateQueryData("getAllTags", undefined, (draft) => {
                                draft.push(data)
                            }));
                        }
                        dispatch(purchasesAuthApi.util.updateQueryData("getAllUserProxies", params, (draft) => {
                            draft.purchases.find(item => item.id === purchase_id)?.tags.push(data)
                        }));
                    }
                } catch { }
            },
        }),
        deleteTag: build.mutation<boolean, {
            tag_id: ITag["id"]
        }>({
            query: ({tag_id}) => ({
                url: "tags/" + tag_id,
                method: "DELETE"
            }),
            invalidatesTags: ["ProxyUser"],
            async onQueryStarted({ tag_id }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    dispatch(tagsAuthApi.util.updateQueryData("getAllTags", undefined, (draft) => {
                        return draft.filter(item => item.id !== tag_id)
                    }));
                } catch { }
            },
        }),
        disconnectTag: build.mutation<IProxy, {
            purchase_id: ITag["id"],
            id: ITag["id"],
            params: {
                page: number,
                limit: number,
                search: string,
                tag_ids: ITag["id"][]
            }
        }>({
            query: ({purchase_id, id}) => ({
                url: `tags/${purchase_id}/disconnect`,
                method: "PUT",
                body: {
                    id
                }
            }),
            async onQueryStarted({ params, purchase_id, id: id_tag }, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    if (data) {
                        dispatch(purchasesAuthApi.util.updateQueryData("getAllUserProxies", params, (draft) => {
                            const purchase = draft.purchases.find(item => item.id === purchase_id);

                            if (purchase) {
                                purchase.tags = purchase.tags.filter(item => item.id !== id_tag);
                            }
                        }));
                    }
                } catch { }
            },
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetAllTagsQuery,
    useAddTagMutation,
    useDeleteTagMutation,
    useDisconnectTagMutation
} = tagsAuthApi;